/**
 * Special long dash character to represent
 * missing, undefined or null values in the UI.
 */
export default '–';
